// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2Iz46","rootSuccess":"CompleteLink_rootSuccess__8jOiN","rootFailure":"CompleteLink_rootFailure__yAGuN","isDisabled":"CompleteLink_isDisabled__2MbgW"};